<template>
  <basic-selects
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="stores"
    :title="`${$t('title.selectstore')}`"
    idProperty="StoreId"
    nameProperty="StoreName"
    allSelectId="storeAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="StoreNumber"
    :defaultItems="defaultItems"
    viewName="StoreSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      stores: [],
      columns: [
        {
          name: "StoreNumber",
        },
        {
          name: "StoreName",
        },
      ],
      id: "storeSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      const vm = this;
      this.$api.stores.getPages(dTO).then((data) => {
        vm.stores = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
